import React from 'react'

import {Button} from '@daedalus/atlas/Button'
import {Grid} from '@daedalus/atlas/helpers/Grid'
import {Icon} from '@daedalus/atlas/Icon'
import {PriceComposition} from '@daedalus/atlas/PriceComposition'
import {Tag} from '@daedalus/atlas/Tag'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {ProviderLogo} from '@daedalus/shared/src/search/ProviderLogo'

import {Offer} from '../../../../types/partnersApi/types'
import {getOfferDDActionName} from '../../../../utils/getOfferDDActionName'
import {OfferInteraction} from '../OfferInteraction'
import {RoomLabels} from './RoomLabels'
import {Skeleton} from './Skeleton'
import {
  ChevronWrapper,
  CtaPriceContentContainer,
  CtaPriceWrapper,
  LabelContainer,
  LogoWrapper,
  OfferCtaWrapper,
  OfferDetailsWrapper,
  RoomName,
  StyledTaxationAndNightlyPriceMessage
} from './styled'

// This should be moved to the new partners package env vars
const baseUrl = 'https://i.fih.io/provider'

interface PrimaryOfferProps {
  offer: Offer
  providerCode: string
  currency: string
  price: number
  anchorPrice?: number
  includeTaxes?: boolean
  hasLowestPrice?: boolean
  onClick?: () => void
}

export const PrimaryOffer = ({
  price,
  currency,
  providerCode,
  offer,
  anchorPrice = 0,
  includeTaxes = false,
  hasLowestPrice = false,
  onClick
}: PrimaryOfferProps) => {
  if (!offer) return <Skeleton />
  return (
    <OfferInteraction offer={offer} onClick={onClick}>
      <OfferDetailsWrapper data-dd-action-name={getOfferDDActionName(1)}>
        <Grid container justify="space-between" spacing="s000" wrap="nowrap">
          <div>
            {hasLowestPrice && (
              <LabelContainer>
                <Tag variant="success" iconStart={<Icon name="Party" />}>
                  <FormattedMessageWrapper
                    id="minPrice"
                    defaultMessage="Lowest price"
                  />
                </Tag>
              </LabelContainer>
            )}
            <LogoWrapper>
              <ProviderLogo
                providerCode={providerCode}
                height={20}
                urlPrefix={baseUrl}
              />
            </LogoWrapper>

            <RoomName dataId="RoomName" variant="labelS">
              {offer.roomName}
            </RoomName>

            <RoomLabels offer={offer} providerCode={providerCode} />
          </div>
          <CtaPriceWrapper
            container
            alignItems="flex-end"
            direction="column"
            justify="flex-end"
            spacing="s000"
          >
            <CtaPriceContentContainer>
              <>
                <span>
                  <PriceComposition
                    showRowLayout
                    showAnchorPrice={anchorPrice > 0}
                    size="xl"
                    price={price}
                    currencyCode={currency}
                    anchorPrice={anchorPrice}
                  />
                </span>
              </>
            </CtaPriceContentContainer>
            <StyledTaxationAndNightlyPriceMessage
              includeTaxes={includeTaxes}
              hasMultipleRooms={false}
            />
            <OfferCtaWrapper data-dd-action-name={getOfferDDActionName(1)}>
              <Button
                variant="primary"
                iconEnd={
                  <ChevronWrapper>
                    <Icon name="ChevronRight" />
                  </ChevronWrapper>
                }
              >
                <FormattedMessageWrapper
                  id="viewDeal"
                  defaultMessage="View Deal"
                />
              </Button>
            </OfferCtaWrapper>
          </CtaPriceWrapper>
        </Grid>
      </OfferDetailsWrapper>
    </OfferInteraction>
  )
}
